/* ==========================================================================
   product-card.js — The Park Wholesale
   Colour swatches on snippets/product-card-2.liquid:
   - click / tap / Enter / Space: show that colour's image, mark it pressed,
     and point the card links at that variant (product page opens in that colour)
   - mouse hover (desktop only): preview the colour, back on leave
   One delegated listener for the whole page; works for cards added later.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__productCardSwatches) return;
  window.__productCardSwatches = true;

  var SWATCH = '.product-card__swatch';
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function cardOf(el) { return el.closest('.product-card'); }
  function imageOf(card) { return card.querySelector('.product-card__image'); }

  function remember(img) {
    if (img.dataset.originalSrc) return;
    img.dataset.originalSrc = img.getAttribute('src') || '';
    img.dataset.originalSrcset = img.getAttribute('srcset') || '';
  }

  function show(card, swatch) {
    var img = imageOf(card);
    if (!img || !swatch.dataset.imageSrc) return;
    remember(img);
    if (swatch.dataset.imageSrcset) img.setAttribute('srcset', swatch.dataset.imageSrcset);
    img.setAttribute('src', swatch.dataset.imageSrc);
  }

  function restore(card) {
    var pressed = card.querySelector(SWATCH + '[aria-pressed="true"]');
    if (pressed) { show(card, pressed); return; }
    var img = imageOf(card);
    if (!img || !img.dataset.originalSrc) return;
    if (img.dataset.originalSrcset) img.setAttribute('srcset', img.dataset.originalSrcset);
    else img.removeAttribute('srcset');
    img.setAttribute('src', img.dataset.originalSrc);
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest(SWATCH);
    if (!swatch) return;
    var card = cardOf(swatch);
    if (!card) return;

    card.querySelectorAll(SWATCH).forEach(function (el) {
      el.setAttribute('aria-pressed', el === swatch ? 'true' : 'false');
    });
    show(card, swatch);

    var url = swatch.dataset.variantUrl;
    if (url) {
      card.querySelectorAll('[data-card-link]').forEach(function (link) { link.setAttribute('href', url); });
    }
  });

  document.addEventListener('mouseover', function (event) {
    if (!canHover.matches || !event.target.closest) return;
    var swatch = event.target.closest(SWATCH);
    if (swatch) show(cardOf(swatch), swatch);
  });

  document.addEventListener('mouseout', function (event) {
    if (!canHover.matches || !event.target.closest) return;
    var swatch = event.target.closest(SWATCH);
    if (!swatch) return;
    var next = event.relatedTarget;
    if (next && next.closest && next.closest(SWATCH) && cardOf(next) === cardOf(swatch)) return;
    restore(cardOf(swatch));
  });
})();